import type { Publisher, YammerState } from '../../state/types';
import { createFindRecordById, createFindRecordByIdThrows } from '../findRecordById';

/**
 * @deprecated PERFORMANCE This selector returns the entire publisher object, which returns a new
 * object instance on EVERY update (i.e. every keystroke while editing). This should be replaced
 * by a `getPublisherField` selector so consumers can select only the fields they require and not
 * be forced to re-render when unrelated fields change.
 */
export const findById = createFindRecordById<Publisher>('publishers');

/**
 * @deprecated PERFORMANCE This selector returns the entire publisher object, which returns a new
 * object instance on EVERY update (i.e. every keystroke while editing). This should be replaced
 * by a `getPublisherFieldThrows` selector so consumers can select only the fields they require and not
 * be forced to re-render when unrelated fields change.
 */
export const findByIdThrows = createFindRecordByIdThrows<Publisher>('publishers');

type GetPublisherField = <T extends keyof Publisher>(
  state: YammerState,
  publisherId: Publisher['id'],
  fieldName: T
) => Publisher[T] | undefined;
export const getPublisherField: GetPublisherField = (state, publisherId, fieldName) => {
  const publisher = findById(state, publisherId);

  if (publisher == null) {
    return undefined;
  }

  return publisher[fieldName];
};
